// extracted by mini-css-extract-plugin
export default {"content":"FmJXIfG6MmGcdfPNNZJy","footer":"ZqeQFUN3PH5AOzTDnGAI","button":"EugW0EpWdjHTsSHkc7TO","pulse":"KTODP9pgkzHUxl5GB_H_"};